export enum PanelKind {
	Metadata,
	Queue,
	Upload,
	None,
}
